<template>
    <div class="contractdetail">
        <nav-bar />
        <search-bar />
        <div class="main">
            <img :src="i" v-for="(i,k) in imgs" :key="k" alt />
        </div>
        <footer-bar />
    </div>
</template>

<script>
import NavBar from "@/components/NavBar";
import SearchBar from "@/components/SearchBar";
import FooterBar from "@/components/FooterBar";
export default {
    data() {
        return {
            imgs: this.getItem("contract_img").split(",")
        };
    },
    components: { NavBar, SearchBar, FooterBar }
};
</script>

<style scoped lang="scss">
.contractdetail {
    font-size: 14px;
    .main {
        width: 1200px;
        background-color: #fff;
        margin: 0 auto;
    }
}
</style>



// WEBPACK FOOTER //
// src/page/me/myContract/contractdetail.vue